import useFieldFocus from '@v4/hooks/useFieldFocus'
import useEditorMeta from '@v4/hooks/useEditorMeta'
import { useMediaQuery, useTheme } from '@material-ui/core'
import useStyles from './Banner6.styled'

export const useBanner6 = props => {
	const { metaData } = props
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const classes = useStyles(props)

	const { handleFocus: handleButtonClick } = useFieldFocus({ metaData: metaData.buttonAction })
	const { handleFocus: handleAdditionalButtonClick } = useFieldFocus({ metaData: metaData.additionalButtonAction })
	const { handleFocus: handleTextClick } = useFieldFocus({ metaData: metaData.text })
	const { handleFocus: handleAdditionalTextClick } = useFieldFocus({ metaData: metaData.additionalText })
	const { handleFocus: handleImageClick } = useFieldFocus({ metaData: metaData.backgroundImage })
	const { editable: textEditable, handleChange: handleTextChange } = useEditorMeta({
		metaData: metaData.text,
		key: 'text',
	})

	const { editable: additionalTextEditable, handleChange: handleAdditionalTextChange } = useEditorMeta({
		metaData: metaData.additionalText,
		key: 'additionalText',
	})

	const { editable: buttonTextEditable, handleChange: handleButtonTextChange } = useEditorMeta({
		metaData: metaData.buttonText,
		key: 'buttonText',
	})

	const { editable: additionalButtonTextEditable, handleChange: handleAdditionalButtonTextChange } = useEditorMeta({
		metaData: metaData.additionalButtonText,
		key: 'additionalButtonText',
	})

	const withBgImage = !!metaData.backgroundImage?.image

	return [
		{
			classes,
			withBgImage,
			backgroundImage: metaData.backgroundImage,
			direction: metaData.alignment?.contentDirection(),
			isMobile,
			textShadow: metaData.textShadow?.toNumber(),
			additionalButtonColor: metaData.additionalButtonColor?.metaValue,

			text: metaData.text?.metaValue,
			textKey: metaData.text?.tierKey,
			textConfig: metaData.text?.config,
			textEditable,

			additionalText: metaData.additionalText?.metaValue,
			additionalTextKey: metaData.additionalText?.tierKey,
			additionalTextConfig: metaData.additionalText?.config,
			additionalTextEditable,

			buttonText: metaData.buttonText?.metaValue,
			buttonTextKey: metaData.buttonText?.tierKey,
			buttonTextConfig: metaData.buttonText?.config,
			buttonAction: metaData.buttonAction?.metaValue,
			buttonLink: metaData.buttonLink?.metaValue,
			buttonTextEditable,

			additionalButtonText: metaData.additionalButtonText?.metaValue,
			additionalButtonTextKey: metaData.additionalButtonText?.tierKey,
			additionalButtonTextConfig: metaData.additionalButtonText?.config,
			additionalButtonAction: metaData.additionalButtonAction?.metaValue,
			additionalButtonLink: metaData.additionalButtonLink?.metaValue,
			additionalButtonTextEditable,
		},
		{
			handleImageClick,

			handleTextClick,
			handleTextChange,

			handleButtonClick,
			handleButtonTextChange,

			handleAdditionalTextClick,
			handleAdditionalTextChange,

			handleAdditionalButtonClick,
			handleAdditionalButtonTextChange,
		},
	]
}
